"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapBackendColorToTheme = void 0;
var _getColorAndShadeKeys = require("./getColorAndShadeKeys");
var _isCorrectColor = require("./isCorrectColor");
var _isCorrectShade = require("./isCorrectShade");
var _isOldColor = require("./isOldColor");
var _mapOldColor = require("./mapOldColor");
/**
 * Maps backend color to color from `theme.pallette` object.
 * @returns Color as `hex string` or `fallBackColor` if color is not found in `theme.pallette`.
 */ var mapBackendColorToTheme = function(param) {
    var backendColor = param.backendColor, _param_fallBackColor = param.fallBackColor, fallBackColor = _param_fallBackColor === void 0 ? '#ffffff' : _param_fallBackColor, palette = param.theme.palette;
    if (!backendColor) {
        return fallBackColor;
    }
    // Check for old colors White, Black, DarkGrey, Brown, Green
    if ((0, _isOldColor.isOldColor)(backendColor)) {
        return (0, _mapOldColor.mapOldColor)(backendColor, palette);
    }
    var _ref;
    var _ref1 = (_ref = (0, _getColorAndShadeKeys.getColorAndShadeKeys)({
        backendColor: backendColor,
        palette: palette
    })) !== null && _ref !== void 0 ? _ref : {}, color = _ref1.color, shade = _ref1.shade;
    if (!color || !shade || !(0, _isCorrectColor.isCorrectColor)(palette, color)) {
        return fallBackColor;
    }
    var paletteColor = palette[color];
    if ((typeof paletteColor === "undefined" ? "undefined" : _type_of(paletteColor)) !== 'object' || !(0, _isCorrectShade.isCorrectShade)(paletteColor, shade)) {
        return fallBackColor;
    }
    return paletteColor[shade];
};
exports.mapBackendColorToTheme = mapBackendColorToTheme; //# sourceMappingURL=mapBackendColorToTheme.js.map
